<template>
  <div class="pages">
    <div class="content">
      <div class="top">
        <img src="../assets/kefu2.png" />
        <span>
          Hello, do you have any questions? You can add wechat below or send
          content to email!
        </span>
      </div>
      <ul>
        <li>wechat：{{ wechat?wechat:"" }}</li>
        <li>mailbox：{{ mail?mail:'' }}</li>
        <li>Telephone：{{ phone?phone:"" }}</li>
        <li>WhatsApp：{{ whatsApp?whatsApp:'' }}</li>
      </ul>
      <div class="ct-img">
        <img :src="url" />
        <span>Scan QR code to add customer service wechat consultation</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'kefu',
  data () {
    return {
      mail: '',
      phone: '',
      wechat: '',
      whatsApp: '',
      url: ''
    };
  },
  created () {
    this.getServiceinfo();
  },
  methods: {
    getServiceinfo () {
      this.$api.serviceinfo({}).then((res) => {
        console.log(res);
        if (res.result == 0) {
          this.mail = res.data.mail;
          this.phone = res.data.phone;
          this.wechat = res.data.wechat;
          this.whatsApp = res.data.whatsApp;
          this.url = res.data.url;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.pages {
  background: #000;
  // display: flex;
  // justify-content: flex-end;
  padding-right: 110px;
  // box-sizing: border-box;
  padding-bottom: 100px;
}
.content {
  width: 817px;
  height: 821px;
  background: #000;
  background-image: url(../assets/kefu-bg.png);
  background-size: 100% 100%;
  padding: 60px 20px 40px 45px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  .top {
    display: flex;
    align-items: center;
    img {
      width: 56px;
      height: 56px;
      display: block;
    }
    span {
      font-size: 24px;
      color: #f6f6f6;
      margin-left: 15px;
      line-height: 1em;
    }
  }
  ul {
    width: 663px;
    height: 224px;
    background: rgba(35, 254, 246, 0.1);
    border: 1px solid #48ece7;
    margin-left: 71px;
    padding: 22px 26px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    li {
      font-size: 24px;
      color: #5ffcff;
      line-height: 1em;
    }
  }
  .ct-img {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-left: 71px;
    img {
      width: 300px;
      height: 300px;
      display: block;
      border: 1px solid #ffffff;
      box-sizing: border-box;
    }
    span {
      display: block;
      margin-top: 27px;
      font-size: 24px;
      color: #ffffff;
      line-height: 1em;
    }
  }
}
</style>
